import React from "react";
import { Bot, ChartBar } from "lucide-react";
import { RIGHT_DOCK_TRIGGER_WIDTH, RIGHT_DOCK_TOP } from "./layoutConstants";

export function AgentReportsRibbon({ isOpen, hasHighlight, onToggle }) {
  const restingShadow = isOpen
    ? "0 4px 12px rgba(0,0,0,0.35)"
    : "0 6px 16px rgba(0,0,0,0.45)";
  const glow = hasHighlight
    ? "0 0 14px rgba(236,16,163,0.8), 0 0 28px rgba(0,0,0,0.45)"
    : restingShadow;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        height: "100vh",
        zIndex: 60,
      }}
    >
      <button
        onClick={onToggle}
        style={{
          position: "relative",
          width: `${RIGHT_DOCK_TRIGGER_WIDTH}px`,
          height: "100%",
          border: "none",
          borderRadius: "12px 0 0 12px",
          padding: "14px 10px",
          background:
            "linear-gradient(180deg, rgba(236,16,163,0.95), rgba(0,0,0,0.45))",
          color: "#ffffff",
          fontSize: "0.75rem",
          letterSpacing: "0.4em",
          textTransform: "uppercase",
          writingMode: "vertical-rl",
          textOrientation: "mixed",
          cursor: "pointer",
          boxShadow: glow,
          transition: "box-shadow 0.3s ease",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        title={"Agent Reports"}
      >
        Reports
      </button>
    </div>
  );
}
